import { __rest } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

var ListsIllustration = function ListsIllustration(_a) {
  var className = _a.className,
    _a$color = _a.color,
    color = _a$color === undefined ? 'sapphire' : _a$color,
    otherProps = __rest(_a, ["className", "color"]);
  return jsxs("svg", Object.assign({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-label": "ListsIllustration",
    role: "img",
    viewBox: "0 0 112 72",
    xmlns: "http://www.w3.org/2000/svg",
    width: "112",
    height: "72",
    fill: "none",
    className: classNames('cogs-illustration', 'cogs-themed-icon', className)
  }, otherProps, {
    children: [jsx("rect", {
      width: "51",
      height: "38",
      y: "10",
      fill: "var(--cogs-decorative--".concat(color, "--400)"),
      opacity: ".3",
      rx: "4"
    }), jsx("g", {
      fill: "var(--cogs-decorative--".concat(color, "--400)"),
      opacity: ".15",
      children: jsx("path", {
        d: "M44.635 19.5H12.74a1.583 1.583 0 1 1 0-3.167h31.895a1.583 1.583 0 1 1 0 3.167M44.635 25.833H12.74a1.583 1.583 0 1 1 0-3.166h31.895a1.583 1.583 0 1 1 0 3.166M12.74 32.167h31.895a1.583 1.583 0 1 0 0-3.167H12.74a1.583 1.583 0 1 0 0 3.167M25.51 38.5H12.74a1.583 1.583 0 1 1 0-3.167h12.77a1.583 1.583 0 1 1 0 3.167M4.781 30.583c0 .875.72 1.584 1.594 1.584s1.594-.71 1.594-1.584S7.249 29 6.375 29s-1.594.709-1.594 1.583M6.375 38.5a1.59 1.59 0 0 1-1.594-1.583c0-.875.72-1.584 1.594-1.584s1.594.71 1.594 1.584-.72 1.583-1.594 1.583M4.781 24.25c0 .874.72 1.583 1.594 1.583s1.594-.709 1.594-1.583c0-.875-.72-1.583-1.594-1.583s-1.594.708-1.594 1.583M6.375 19.5a1.59 1.59 0 0 1-1.594-1.583c0-.875.72-1.584 1.594-1.584s1.594.71 1.594 1.584-.72 1.583-1.594 1.583"
      })
    }), jsx("rect", {
      width: "51",
      height: "38",
      x: "61",
      y: "10",
      fill: "var(--cogs-decorative--".concat(color, "--400)"),
      opacity: ".3",
      rx: "4"
    }), jsx("g", {
      fill: "var(--cogs-decorative--".concat(color, "--400)"),
      opacity: ".15",
      children: jsx("path", {
        d: "M105.635 19.5H73.74a1.583 1.583 0 1 1 0-3.167h31.895a1.584 1.584 0 1 1 0 3.167M105.635 25.833H73.74a1.583 1.583 0 1 1 0-3.166h31.895a1.583 1.583 0 1 1 0 3.166M73.74 32.167h31.895a1.584 1.584 0 1 0 0-3.167H73.74a1.583 1.583 0 1 0 0 3.167M86.51 38.5H73.74a1.583 1.583 0 1 1 0-3.167h12.77a1.583 1.583 0 1 1 0 3.167M65.781 30.583c0 .875.72 1.584 1.594 1.584s1.594-.71 1.594-1.584S68.249 29 67.375 29s-1.594.709-1.594 1.583M67.375 38.5a1.59 1.59 0 0 1-1.594-1.583c0-.875.72-1.584 1.594-1.584s1.594.71 1.594 1.584-.72 1.583-1.594 1.583M65.781 24.25c0 .874.72 1.583 1.594 1.583s1.594-.709 1.594-1.583c0-.875-.72-1.583-1.594-1.583s-1.594.708-1.594 1.583M67.375 19.5a1.59 1.59 0 0 1-1.594-1.583c0-.875.72-1.584 1.594-1.584s1.594.71 1.594 1.584-.72 1.583-1.594 1.583"
      })
    }), jsx("rect", {
      width: "64",
      height: "48",
      x: "24",
      y: "20",
      fill: "#fff",
      rx: "4"
    }), jsx("rect", {
      width: "64",
      height: "48",
      x: "24",
      y: "20",
      fill: "var(--cogs-decorative--".concat(color, "--400)"),
      opacity: ".5",
      rx: "4"
    }), jsx("g", {
      fill: "var(--cogs-decorative--".concat(color, "--400)"),
      opacity: ".5",
      children: jsx("path", {
        d: "M80 32H40a2 2 0 1 1 0-4h40a2 2 0 1 1 0 4M80 40H40a2 2 0 1 1 0-4h40a2 2 0 1 1 0 4M40 48h40a2 2 0 1 0 0-4H40a2 2 0 1 0 0 4M56 56H40a2 2 0 1 1 0-4h16a2 2 0 1 1 0 4M30 46a2 2 0 1 0 4 0 2 2 0 0 0-4 0M32 56a2 2 0 1 1 0-4 2 2 0 0 1 0 4M30 38a2 2 0 1 0 4 0 2 2 0 0 0-4 0M32 32a2 2 0 1 1 0-4 2 2 0 0 1 0 4"
      })
    })]
  }));
};

export { ListsIllustration };
